import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BonusProcessingTransactionsState } from "./types";
import { ErrorType } from "@/shared/types";
import { fetchBonusProcessingTransactions } from "./bonus-processing-transactions-thunk";

const currentDate = new Date()

const initialState: BonusProcessingTransactionsState = {
    transactions: [],
    isLoading: false,
    isFirstLoad: true,
    error: null,
    page: 1,
    limit: 50,
    totalPages: 0,
    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    bonusId: null,
    withAccrual: 'all'
}

const bonusProcessingTransactionsSlice = createSlice({
    name: 'bonusProcessingTransactions',
    initialState,
    reducers: {
        nextPage: (state) => {
            if (state.page < state.totalPages) {
                state.page += 1
            }
        },
        setStartDate: (state, action: PayloadAction<Date>) => {
            state.startDate = action.payload
        },
        setEndDate: (state, action: PayloadAction<Date>) => {
            state.endDate = action.payload
            state.page = 1
            state.transactions = []
            state.isFirstLoad = true
            state.totalPages = 0
        },
        setSelectedBonus: (state, action: PayloadAction<string | null>) => {
            state.bonusId = action.payload ? [action.payload] : null
            state.page = 1
            state.transactions = []
            state.isFirstLoad = true
            state.totalPages = 0
        },
        setWithAccrual: (state, action: PayloadAction<'all' | 'true' | 'false'>) => {
            state.withAccrual = action.payload
            state.page = 1
            state.transactions = []
            state.isFirstLoad = true
            state.totalPages = 0
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchBonusProcessingTransactions.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchBonusProcessingTransactions.fulfilled, (state, action) => {
                state.isFirstLoad = false
                state.isLoading = false
                state.transactions = [...state.transactions, ...action.payload.items]
                state.error = null
                state.totalPages = action.payload.totalPages
            })
            .addCase(fetchBonusProcessingTransactions.rejected, (state, action) => {
                state.error = action.payload as ErrorType ?? null
                state.isLoading = false
            })
    },
})

export default bonusProcessingTransactionsSlice.reducer
export const { nextPage, setSelectedBonus, setEndDate, setStartDate, setWithAccrual } = bonusProcessingTransactionsSlice.actions
